const COLOR_CHIP = {
  PRODUCTS_WHITE: 'WHITE',
  PRODUCTS_SIMPLYWHT: 'SIMPLYWHT',
};
const PLP_COLOR_SWATCH_SCROLL_CONFIG = {
  tablet: { thresholdItems: 9, scrollWidth: 22 },
  mobile: { thresholdItems: 6, scrollWidth: 22 },
  desktop: { thresholdItems: 7, scrollWidth: 32 },
};

const NEW_PLP_COLOR_SWATCH_SCROLL_CONFIG = {
  tablet: { thresholdItems: 9, scrollWidth: 22 },
  mobile: { thresholdItems: 6, scrollWidth: 26 },
  desktop: { thresholdItems: 7, scrollWidth: 28 },
};

const HLP_COLOR_SWATCH_SCROLL_CONFIG = {
  tablet: { thresholdItems: 5, scrollWidth: 24 },
  mobile: { thresholdItems: 6, scrollWidth: 22.2 },
  desktop: { thresholdItems: 6, scrollWidth: 24 },
};

const PLP_SLP_COLOR_SWATCH_DIMENSIONS = {
  mobile: { width: 15, height: 15, marginRight: 7 },
  tablet: { width: 18, height: 18, marginRight: 8 },
  desktop: { width: 20, height: 20, marginRight: 8 },
  remainingSwatchesTextWidth: 23,
};

const INTERACTIVE_PLP_SLP_COLOR_SWATCH_DIMENSIONS = {
  width: 20,
  height: 20,
  remainingSwatchesTextWidth: 23,
  containerGap: 8,
  containerSidePadding: 10,
};

const favValueoutline = 'fav-icon-outline';
const favValuesolid = 'fav-icon-solid';
const FAV_ICON_NAME_MAP = {
  'snj-outline': 'fav-icon-snj',
  'snj-solid': 'fav-icon-fill-snj',
  'tcp-outline': favValueoutline,
  'tcp-solid': favValuesolid,
  'gym-outline': favValueoutline,
  'gym-solid': favValuesolid,
  'pjp-outline': 'fav-icon-pjp',
  'pjp-solid': 'fav-icon-fill-pjp',
};
const PRODUCT_BRAND_NAME_MAP = {
  tcp: `The Children's Place`,
  gym: `Gymboree`,
  snj: `Sugar & Jade`,
  pjp: `PJ Place`,
};
const IMG_BASE_DIMENTION = {
  baseHeight: 2300,
  baseWidth: 1850,
};
const NEXT_IMG_PLP_TRANS_CONFIG = {
  image: 'f_auto,w_256,q_75',
  video: 'fl_animated,fl_awebp,e_loop,w_256,q_75,vs_100',
};
const PLP_TILE_IMAGE_WIDTH = {
  mobile: 146,
  desktop: 196,
};

export const plpTileClassName = 'plp-tile-ref';

export {
  COLOR_CHIP,
  PLP_COLOR_SWATCH_SCROLL_CONFIG,
  NEW_PLP_COLOR_SWATCH_SCROLL_CONFIG,
  PLP_SLP_COLOR_SWATCH_DIMENSIONS,
  HLP_COLOR_SWATCH_SCROLL_CONFIG,
  FAV_ICON_NAME_MAP,
  PRODUCT_BRAND_NAME_MAP,
  IMG_BASE_DIMENTION,
  NEXT_IMG_PLP_TRANS_CONFIG,
  PLP_TILE_IMAGE_WIDTH,
  INTERACTIVE_PLP_SLP_COLOR_SWATCH_DIMENSIONS,
};
